import { Controller } from "@hotwired/stimulus"

// Client-side row filter for small tables (e.g. positions of a paczka
// przelewów): rows carry their searchable text in data-filter-text and are
// hidden when they don't match the query. Purely cosmetic — the server
// always renders the full set.
export default class extends Controller {
  static targets = ["query", "row", "empty"]

  filter() {
    const query = this.queryTarget.value.trim().toLowerCase()
    let visible = 0

    this.rowTargets.forEach((row) => {
      const match = !query || (row.dataset.filterText || "").includes(query)
      row.classList.toggle("hidden", !match)
      if (match) visible++
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visible > 0)
    }
  }
}
